import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PostReportReasonEnum } from '../../enum';

export function buildForm() {
  return new FormGroup({
    reason: new FormControl(PostReportReasonEnum.OtherReasons, [
      Validators.required,
    ]),
    description: new FormControl(null, DescriptionValidators),
  });
}

export const DescriptionValidators = [
  Validators.required,
  Validators.maxLength(500),
];
